import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPISites {
    //This method returns all of an organization's sites.
    getAllSites() {
        return fetchJSON("/sites");
    }
    //This method returns a single site by its unique ID.
    getSpecificSite(siteID) {
        return fetchJSON(`/sites/${siteID}`);
    }
    //This method creates a new site.
    createNewSite(params) {
        return fetchJSON("/sites", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method modifies the name or perimeter coordinates of a site.
    modifyExistingSite(siteID, params) {
        return fetchJSON(`/sites/${siteID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes an existing site.
    deleteExistingSite(siteID) {
        return fetchWithAuth(`/sites/${siteID}`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-sites.js.map